import router from './router/index'
import axios from 'axios'

const init = function () {
  // 路由跳转前
  router.beforeEach((to, from, next) => {
    // 判断是路径，matched.length > 0 并且  to.matched[0].path有值 则为 a/:d模式, 取to.matched[0].path， 否则取to.path
    // let path = to.matched.length && to.matched[0].path ? to.matched[0].path : to.path
    // checkPermission(path).then(data => {
    //   if (data.data === 'true') return next()
    //   return window.Alert(window.I18n.noJurisdiction)
    // })
    next()
  })
}

function checkPermission(path) {
  return axios.get('platform/v1/access/resources?', {
    params: {
      requestUrl: path,
      httpMethod: 'GET',
      serviceName: window.localHost,
      type: 'FRONTEND_URL'
    },
    noLoading: true
  })
}

export {
  init,
  checkPermission
};



// WEBPACK FOOTER //
// ./src/config.js